var app_server = "https://pcapi.xmoty.com"; //生产环境
// var app_server = "https://testpcapi.xmoty.com"; //测试环境
//   var app_server = 'http://localhost:8888';//本地
// var app_server = 'http://192.168.50.186:8888';//蓝华伟
// var app_server = 'http://192.168.50.192:18888';//陈金
//  var app_server = 'http://192.168.50.192:8888'//刘小波环境
//   var app_server = 'http://192.168.50.224:8888';//黄伟
//   var app_server = 'http://192.168.50.218:18888';//主管

export { app_server };



// WEBPACK FOOTER //
// ./src/helper/EnvConfig.js